import React from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Fade from '@mui/material/Fade';
import {useSelector} from 'react-redux'
import IntlMessages from 'util/IntlMessages';
import usePostUserSearchHistory from '../../hooks/api/user/usePostUserSearchHistory';
import { useGetUserSearchHistory } from '../../hooks/api/user/useGetUserSearchHistory';
import { Autocomplete, TextField } from '@mui/material'
import HistoryIcon from '@mui/icons-material/History';
import moment from 'moment-timezone';

const SearchBox = ({styleName,
  placeholder,
  onChange,
  value,
  seachtype,
  ontypeChange,
  searchFor,
  handleKeyPress,
  BText,
  onChangeBText
}) => { 
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const authUser = useSelector(state => state.auth.authUser)
  const width = useSelector(state=> state.settings.width)

	const {mutate} = usePostUserSearchHistory()
	const {data, isLoading} = useGetUserSearchHistory(0, value)
    
	// const handleSearch = (event)=>{
	// 	searchFor(event)
	// 	mutate({Keyword: event.target.value, Source: 0})
	// }
	console.log(data, 'search history')

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const getBtext=()=>{
    switch(parseInt(BText)){
      case 0: return <IntlMessages id="Existing" />
      case 1: return <IntlMessages id="Nya" />
      case 2: return <IntlMessages id="Both" />
      default: return <IntlMessages id="Existing" />
    }
  }

  const _handleKeyPress = e => {
		if(handleKeyPress) handleKeyPress(e)	
    if (e.key === "Enter") mutate({Keyword: value, Source: 0})
	}
  const _searchFor = e => {
		searchFor(e)	
		mutate({Keyword: value, Source: 0})
	}

	console.log(moment().fromNow(), 'fffaaaf')

  return (
    <div className={`search-bar right-side-icon bg-transparent ${styleName}`}
    >
       <div class="input-group">
        <div class="input-group-prepend">
          <div class="input-group-text">
          <Button
        id="fade-button"
        aria-controls={open ? 'fade-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        size="small"
        disabled={parseInt(authUser.user_Licans) === 1 || parseInt(authUser.user_Licans) === 5 || parseInt(authUser.user_Licans) === 5}
        style={{padding:0,lineHeight:1.5}}
      >
        {getBtext()}
      </Button>
      <Menu
        id="fade-menu"
        MenuListProps={{
          'aria-labelledby': 'fade-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        TransitionComponent={Fade}
      >
        <MenuItem data-preventclose={true}  onClick={(e)=>{
          onChangeBText(0)
          handleClose()
        }}
        style={{display:"block",paddingLeft:16,paddingRight:16}}
        ><IntlMessages  id="Existing" /></MenuItem>
        {
          parseInt(authUser.user_Licans) !== 1 &&
          <>
          <MenuItem data-preventclose={true}  onClick={(e)=>{
          onChangeBText(1)
          handleClose()
        }}
        style={{display:"block",paddingLeft:16,paddingRight:16}}
        ><IntlMessages  id="Nya" /></MenuItem>
        <MenuItem data-preventclose={true}  onClick={(e)=>{
          onChangeBText(2)
          handleClose()
        }}
        style={{display:"block",paddingLeft:16,paddingRight:16}}
        ><IntlMessages id="Both" /></MenuItem>
          </>
        }
        
      </Menu>
          </div>
        </div>
				<Autocomplete
					style={{ backgroundColor: '#fff'}}
					size='small'
					freeSolo
					onKeyPress={_handleKeyPress}
					options={!data ? [] : data.SearchHistory.map(s => ({...s, label: s.Keyword}))}
					filterOptions={(options, filter) => {
						if(filter.inputValue === "")
							return options
						else
							return options.filter(o => 
								String(o.label).replace(/\s/g, '').toUpperCase().includes(String(filter.inputValue).replace(/\s/g, '').toUpperCase()) 
							)
          }}
					componentsProps={{
						popper: {style: {width:'fit-content'}, placement:'bottom-start'},
						paper: {style: {marginTop: 0}}
					}}
 					sx={{
							minWidth: {xs: '158px', sm: '259px'},
							borderRadius: 0,
							"& .MuiOutlinedInput-root": {
									borderRadius: "0",
									paddingTop: "4px !important",
									paddingBottom: "4px !important",
							},
							"& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
									border: "1px solid #eee"
							}
					}}
					renderOption={(props, option)=>{
						return (
							<MenuItem {...props}>
								<div className='d-flex align-items-center justify-content-between w-100' style={{gap: 20, color: '#2f353a'}}>
									<span style={{whiteSpace: 'nowrap', gap: 5}} className='d-flex align-items-center'>
										<HistoryIcon/>
										<span>{option.label}</span>
									</span>

									<small style={{whiteSpace: 'nowrap'}}>{moment().diff(option.sdate) > 0 ? moment(option.sdate).fromNow() : moment().fromNow()}</small>
								</div>
							</MenuItem>
						)
					}}
					loadingText={<IntlMessages id="Search.Loading"/>}
					onChange={(e, value)=> {
						console.log(e, value, 'vvalse')
						if(value?.label) onChange({target: {value: value.label}})
					}}	
					value={value}
					loading={isLoading}
					renderInput={(params) => <TextField {...params} 
						onChange={(e)=> {
						 	console.log(e.target.value, 'valuechange')
							onChange(e)
						}
					} label={placeholder}  />}
				/>
        {/* <input className="form-control border-0" type="search"
         placeholder={placeholder} 
         onChange={onChange}
         style={{background:"#fff"}}
         value={value}
         onKeyPress={handleKeyPress}/> */}
         <div class="input-group-prepend">
          <div class="input-group-text" style={{borderRadius: '0px 5px 5px 0px'}}>
          <Button
          onClick={_searchFor}
          size="small"
          style={{padding:0,lineHeight:1.5,minWidth:25}}
          >
            <i className="zmdi zmdi-search zmdi-hc-lg"/>
          </Button>
        </div>
        </div>
      </div>
     
    </div>
  )
};
export default SearchBox;

SearchBox.defaultProps = {
  styleName: "",
  value: "",
};